import { DrawBannerImage } from "../../assets";
import theme from "../../theme/Theme";

export const styles = {
  pageContainer: {
    position: "relative",
  },
  pageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: "-20%",
    zIndex: -1,
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556l-1.414-1.414L28 0h4zM.284 0l28 28-1.414 1.414L0 2.544V0h.284zM0 5.373l25.456 25.455-1.414 1.415L0 8.2V5.374zm0 5.656l22.627 22.627-1.414 1.414L0 13.86v-2.83zm0 5.656l19.8 19.8-1.415 1.413L0 19.514v-2.83zm0 5.657l16.97 16.97-1.414 1.415L0 25.172v-2.83zM0 28l14.142 14.142-1.414 1.414L0 30.828V28zm0 5.657L11.314 44.97 9.9 46.386l-9.9-9.9v-2.828zm0 5.657L8.485 47.8 7.07 49.212 0 42.143v-2.83zm0 5.657l5.657 5.657-1.414 1.415L0 47.8v-2.83zm0 5.657l2.828 2.83-1.414 1.413L0 53.456v-2.83zM54.627 60L30 35.373 5.373 60H8.2L30 38.2 51.8 60h2.827zm-5.656 0L30 41.03 11.03 60h2.828L30 43.858 46.142 60h2.83zm-5.656 0L30 46.686 16.686 60h2.83L30 49.515 40.485 60h2.83zm-5.657 0L30 52.343 22.343 60h2.83L30 55.172 34.828 60h2.83zM32 60l-2-2-2 2h4zM59.716 0l-28 28 1.414 1.414L60 2.544V0h-.284zM60 5.373L34.544 30.828l1.414 1.415L60 8.2V5.374zm0 5.656L37.373 33.656l1.414 1.414L60 13.86v-2.83zm0 5.656l-19.8 19.8 1.415 1.413L60 19.514v-2.83zm0 5.657l-16.97 16.97 1.414 1.415L60 25.172v-2.83zM60 28L45.858 42.142l1.414 1.414L60 30.828V28zm0 5.657L48.686 44.97l1.415 1.415 9.9-9.9v-2.828zm0 5.657L51.515 47.8l1.414 1.413 7.07-7.07v-2.83zm0 5.657l-5.657 5.657 1.414 1.415L60 47.8v-2.83zm0 5.657l-2.828 2.83 1.414 1.413L60 53.456v-2.83zM39.9 16.385l1.414-1.414L30 3.658 18.686 14.97l1.415 1.415 9.9-9.9 9.9 9.9zm-2.83 2.828l1.415-1.414L30 9.313 21.515 17.8l1.414 1.413 7.07-7.07 7.07 7.07zm-2.827 2.83l1.414-1.416L30 14.97l-5.657 5.657 1.414 1.415L30 17.8l4.243 4.242zm-2.83 2.827l1.415-1.414L30 20.626l-2.828 2.83 1.414 1.414L30 23.456l1.414 1.414zM56.87 59.414L58.284 58 30 29.716 1.716 58l1.414 1.414L30 32.544l26.87 26.87z' fill='%23f2f2f2' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E\")",
  },
  bannerImage: {
    backgroundImage: `url(${DrawBannerImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100vw",
    position: "relative",
  },
  bannerTitle: {
    width: "50%",
    fontSize: { xs: "1rem", lg: "1.8rem" },
    fontWeight: 600,
    color: theme.custom.white,
    textTransform: "uppercase",
    lineHeight: 1.2,
    marginBottom: "0.5em",
  },
  bannerHeading: {
    width: { xs: "100%", lg: "60%" },
    fontSize: { xs: "2rem", lg: "2.8rem" },
    fontWeight: 700,
    color: theme.custom.white,
    textTransform: "uppercase",
    lineHeight: 1.2,
  },
  pageContent: { padding: { xs: "1em 2em", lg: "3em 4em" } },
  filterRow: {
    display: "flex",
    flexDirection: { xs: "column", lg: "row" },
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "1em",
  },
  paginationCount: {
    color: "rgba(82, 82, 82, 1)",
    fontSize: { xs: "1rem", lg: "1.2rem" },
    fontWeight: 700,
    lineHeight: 1.5,
    textTransform: "uppercase",
  },
  filterButtonStyle: {
    backgroundColor: theme.custom.white,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "8px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  filterButtonText: {
    color: "rgba(46, 46, 48, 1)",
    fontSize: { xs: "0.8rem", sm: "0.8rem", lg: "1rem" },
    fontWeight: "700",
    marginLeft: "5px",
  },
  menuItemText: {
    color: "rgba(46, 46, 48, 1)",
    fontSize: { xs: "0.8rem", sm: "0.8rem", lg: "1rem" },
    fontWeight: "700",
  },
  competitionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "1em",
    margin: { sx: 1, md: 2, lg: 3 },
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    aspectRatio: "16/9",
  },
  titleContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    padding: "0.5em 1em",
    zIndex: 3,
  },
  competitionCardImage: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    width: "100%",
    aspectRatio: "16/9",
    objectFit: "fill",
    borderRadius: "1em 1em 0 0",
    zIndex: 2,
  },
  competitionCardTitle: {
    fontSize: { xs: "3.5vw", lg: "1.6vw" },
    fontWeight: "800",
    color: theme.custom.white,
    textTransform: "uppercase",
    textAlign: "center",
  },
  blockchainIcon: {
    margin: "0 0.5em",
  },
  totalPoolPriceText: {
    fontSize: { xs: "3.2vw", lg: "1.2vw" },
    fontWeight: 500,
    color: theme.palette.text.primary,
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    marginLeft: "1em",
    padding: "0.3em 1em 0.3em 1em",
    display: "block",
    width: "max-content",
    marginBottom: "1em",
  },
  totalPoolPriceTicker: {
    fontWeight: 600,
    fontSize: { xs: "2vw", sm: "2.5", md: "0.8vw", lg: "0.8vw" },
    color: theme.palette.primary.main,
  },
  totalPoolPriceValueText: {
    fontWeight: 600,
    fontSize: { xs: "3.5vw", sm: "3.5", md: "1.4vw", lg: "1.5vw" },
    color: theme.palette.primary.main,
  },
  otherTitleText: {
    fontSize: { xs: "3vw", lg: "1vw" },
    fontWeight: 600,
    color: "#706F6F",
    lineHeight: 1.2,
  },
  otherPriceValueText: {
    fontWeight: 600,
    fontSize: { xs: "3.5vw", lg: "1.2vw" },
    color: "#3F3F42",
    lineHeight: 1.2,
  },
  progressBarContainer: {
    position: "relative",
    height: "10px",
    width: "100%",
    borderRadius: "10em",
    overflow: "hidden",
    backgroundColor: "#DADADA",
  },
  soldTickers: {
    backgroundColor: "#0093E9",
    backgroundImage:
      "linear-gradient(90deg, #2AF598 0%, #eae608 31%, #fb9b03 65%, #ff0004 100%)",
    height: "10px",
    borderRadius: "10em",
  },
  progressText: {
    fontSize: { xs: "2.6vw", lg: "1vw" },
    fontWeight: 600,
    color: "#3E3E3E",
    lineHeight: 1.2,
  },
  competitionCardDescription: {
    fontSize: { xs: "2.6vw", lg: "1vw" },
    fontWeight: "600",
    color: "rgba(82, 82, 82, 1)",
  },
  competitionCardButton: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  competitionCardContent: {
    paddingTop: "0.5em",
  },
  daysText: {
    color: "#3F3F42",
    fontSize: { xs: "2.6vw", lg: "1vw" },
    fontWeight: 600,
  },
  pricePerTicket: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "1em",
  },
  joinButtonText: {
    backgroundColor: theme.palette.primary.main,
    padding: "0.5em 1.4em",
    borderBottomRightRadius: "1em",
    borderTopLeftRadius: "1em",
    color: "white",
    fontSize: { xs: "2.6vw", lg: "1vw" },
    fontWeight: "500",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "2em",
    marginBottom: "2em",
  },
  itemAlignJustify: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  paginationCurrentPageText: {
    fontSize: "clamp(0.8rem, 3vw, 1rem)",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  filterSortButton: {
    backgroundColor: theme.custom.white,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: `${theme.palette.primary.main} 3px 3px`,
    borderRadius: "8px",
    px: 2,
    textAlign: "center",
    fontSize: "clamp(0.6rem, 3vw, 0.8rem)",
    fontWeight: 600,
    transition: "border 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
    "&:hover": {
      border: `1px solid ${theme.palette.secondary.main}`,
      // boxShadow: `${theme.palette.secondary.main} 3px 3px`,
    },
  },
  drawFilterMenuItem: {
    fontSize: "clamp(0.6rem, 3vw, 0.8rem)",
    fontWeight: 500,
    color: theme.palette.text.light,
  },
  itemAlignCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  noRecordImage: {
    width: "30%",
  },
  noRecordText: {
    fontSize: "1rem",
    fontWeight: 600,
    color: theme.custom.emperor,
  },
  noRecordContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
  },
};
